module.exports = __webpack_public_path__ + "img/jan-5.c46372eb.jpg";